import { ButtonIconProps } from "ds/components/ButtonIcon";

import { AnnouncementTileBackgroundType } from ".";

export const getDismissButtonVariant = (
  type: AnnouncementTileBackgroundType
): ButtonIconProps["variant"] => {
  switch (type) {
    case AnnouncementTileBackgroundType.Clouds:
      return "ghostInversed";
    case AnnouncementTileBackgroundType.Planets:
      return "ghostInversed";
  }
};
